// extracted by mini-css-extract-plugin
module.exports = {"disabled":"style_disabled__2t1UA"};